module.exports = __webpack_public_path__ + "img/book_of_shadows.40deadac.png";